import React from 'react';
import { Grid } from '@material-ui/core';
import { Special } from 'components/SpecialThumbnailView';
import WkblVideoVO from 'commons/vo/WkblVideoVO';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/reducers/type';
import useStorage from 'hooks/useStorage';

function SpecialThumbnailView() {
  const { specialVideoList } = useSelector((state: RootState) => state.wkblSpecialVideo);
  const { getStorage } = useStorage();

  return (
    <Grid container spacing={2}>
      {specialVideoList.map((specialVideo: WkblVideoVO, index: number) => {
        const storage = getStorage(specialVideo.categoryId);
        specialVideo.symbolicPath = storage.symbolicPath;

        return (
          <Special key={`${specialVideo.id}_${index}`} specialVideo={specialVideo} index={index} />
        );
      })}
    </Grid>
  );
}

export default SpecialThumbnailView;
